import { PushToDataLayer } from "@asosteam/asos-web-event-tracking-bridge";
import { getConsentCategoryIds } from "@/components/consent";

export const emitConsentChangedEvent = (pushToDataLayer: PushToDataLayer) => {
  const consent = getConsentCategoryIds() || "";

  pushToDataLayer({
    OneTrustGroupsUpdated: {
      OnetrustActiveGroups: consent,
    },
  });
};
